// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3EZZY","containerItemsCenter":"Skeleton_containerItemsCenter__2LmK4"};